import { create } from 'zustand'

interface IMenuStore {
  open: boolean
  setOpen: (open: boolean) => void
}

export const useMenuStore = create<IMenuStore>((set) => ({
  open: false,
  setOpen: (open: boolean) => set((state) => ({ open }))
}))
